import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import http from "../../common/cticApi";
import { updateLastActivity } from "./idleSlice";
import { setSession } from "../../common/utils";

const encryptedLoginInfo = window.localStorage.getItem("userInfo");
let decryptedLoginInfo = null;
try {
  if (encryptedLoginInfo) {
    const decryptedBytes = CryptoJS.AES.decrypt(
      encryptedLoginInfo,
      process.env.REACT_APP_CRYPTO_KEY
    );
    decryptedLoginInfo = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
    if (!decryptedLoginInfo && typeof decryptedLoginInfo !== "object") {
      decryptedLoginInfo = null;
    }
  }
} catch (err) {
  decryptedLoginInfo = null;
}

let userInfoFromStorage = decryptedLoginInfo;

try {
  if (!userInfoFromStorage) {
    userInfoFromStorage = null;
  }
} catch (error) {
  userInfoFromStorage = null;
}

// initial state
export const initialState = {
  loading: false,
  error: null,
  userLogin: userInfoFromStorage,
  isAuthenticated: userInfoFromStorage !== null ? true : false,
  isUserLoggedInWithOkta: false,
};

// our slice
const authLoginSlice = createSlice({
  name: "authLogin",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setUserLogin: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.userLogin = payload;
      state.isAuthenticated = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.userLogin = null;
      state.isAuthenticated = false;
    },
    setLogout: (state) => {
      state.loading = false;
      state.error = false;
      state.userLogin = null;
      state.isAuthenticated = false;
    },
    resetErrors: (state) => {
      state.loading = false;
      state.error = false;
    },
    setIsUserLoggedInWithOkta: (state) => {
      state.isUserLoggedInWithOkta = true;
    },
  },
});
// export the actions
export const {
  setLoading,
  setUserLogin,
  setError,
  setLogout,
  resetErrors,
  setIsUserLoggedInWithOkta,
} = authLoginSlice.actions;

export const authLoginSelector = (state) => state.authLogin;

// export the default reducer
export default authLoginSlice.reducer;

// login user
export const loginUser =
  (username, password, data, value, oktaId) => async (dispatch) => {
    try {
      dispatch(setLoading());

      let requestData = {
        userName: username,
        password: password,
      };

      let url = window?.__ENV?.USER_LOGIN_URL;
      if (data && value) {
        url = url + `${data}/${value}`;
      }

      let { data: response } = await http.post(url, requestData);
      if (response.responseCode == 0) {
        dispatch(setUserLogin(response.responseObject));
        dispatch(updateLastActivity());
        setSession();
        window.localStorage.setItem(
          "userInfo",
          CryptoJS.AES.encrypt(
            JSON.stringify(response.responseObject),
            process.env.REACT_APP_CRYPTO_KEY
          ).toString()
        );
      } else {
        dispatch(setError(response.responseDescription));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

// logout user
export const logoutUser = () => async (dispatch) => {
  window.localStorage.removeItem("session");
  window.localStorage.removeItem("userInfo");
  window.localStorage.removeItem("dashboardLawFirm");
  window.localStorage.removeItem("selectedFirmId");
  window.localStorage.removeItem("selectedFirm");
  window.localStorage.removeItem("isFileOpenedfromTT");
  window.localStorage.removeItem("TTFileID");
  window.localStorage.removeItem("CorporationID");
  window.localStorage.removeItem("PurchaserID");
  window.localStorage.removeItem("FileDetails");
  window.localStorage.removeItem("ProgramCodeDetails");
  dispatch(setLogout());
};
